import './styles.css'
import { loadClarity } from './clarity'
import { fetchRuntimeConfig } from './config'
import { initForm } from './form/controller'
import { initTurnstile } from './form/turnstile'
import { initResizeChild } from './resize-child'

// The form is fully usable immediately; analytics + CAPTCHA attach as soon
// as the public runtime config arrives.
initForm()
initResizeChild()

void fetchRuntimeConfig().then((cfg) => {
  loadClarity(cfg.clarityProjectId)
  initTurnstile(cfg.turnstileSiteKey)
})
